import GetLinkPreviewRequest from 'owa-service/lib/contract/GetLinkPreviewRequest';
import GetLinkPreviewResponse from 'owa-service/lib/contract/GetLinkPreviewResponse';
import getLinkPreviewOperation from 'owa-service/lib/operation/getLinkPreviewOperation';

function configureRequestBody(url: string, id: string): GetLinkPreviewRequest {
    return { Url: url, Id: id };
}

export default async function getLinkPreview(
    url: string,
    id: string
): Promise<GetLinkPreviewResponse> {
    let requestBody = configureRequestBody(url, id);
    return getLinkPreviewOperation({ getLinkPreviewRequest: requestBody });
}
